import { Form } from 'react-bootstrap';
import { StatusTags } from '../StatusTags';
import { getUnitProperty } from '../../schemas/unitSchema';

export const StatusSection = ({
  selectedUnitItem,
  classifiedIssuesbyUnitAndKey
}) => {
  const unitId = getUnitProperty(selectedUnitItem, 'unit');
  const unitIssues = classifiedIssuesbyUnitAndKey[unitId] ?? null;

  return (
    <Form.Group className="text-start" controlId="editIssueStatus" style={{ marginBottom: '1.2rem' }}>
      <Form.Label><strong>STATUS</strong></Form.Label>
      <StatusTags
        selectedUnitItem={selectedUnitItem}
        unitIssues={unitIssues}
      />
    </Form.Group>
  );
};